import { useCallback, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import dayjs from "dayjs";

import { dateTimeApiFormat } from "../../../..";
import { warn } from "../../../../modules/messages";
import CheckboxItem from "../../../app/generic/form/checkboxItem";

const CheckboxInfo = ({
  labelId,
  hasError,
  fieldName,
  messageId,
  className,
  onSetHasError,
  onAgreeChange,
  formItemLayout,
  labelDefaultMessage,
  messageDefaultMessage,
}) => {
  const intl = useIntl();

  const handleClick = useCallback(
    ({ target }) => {
      onSetHasError(!target.checked);
      onAgreeChange(
        target.checked ? dayjs().format(dateTimeApiFormat) : undefined
      );
    },
    [onAgreeChange, onSetHasError]
  );

  const [error, setError] = useState();
  useEffect(() => {
    if (hasError) {
      const message = intl.formatMessage({
        id: messageId,
        defaultMessage: messageDefaultMessage,
      });
      setError(message);
      warn(message);
    } else {
      setError();
    }
  }, [intl, hasError, messageId, messageDefaultMessage]);

  return (
    <CheckboxItem
      error={error}
      fieldName={fieldName}
      className={className}
      onChange={handleClick}
      formItemLayout={formItemLayout}
      checkboxLabel={
        <FormattedMessage id={labelId} defaultMessage={labelDefaultMessage} />
      }
    />
  );
};

export default CheckboxInfo;
